module.exports = __webpack_public_path__ + "static/media/cg.46462618.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cg.svg
// module id = 2061
// module chunks = 0